import moment from "moment";
import {CalendarDate} from "@internationalized/date";

export function backendDateToString(date: string): string {
    // Converts a date from the backend format (YYYY-MM-DD) to a human-readable format (DD.MM.YYYY)
    return moment(date).format("DD.MM.YYYY");
}

export function calendarDateToString(date: CalendarDate): string {
    // Converts a CalendarDate object to a human-readable format (DD.MM.YYYY)
    return moment(date.toString()).format("DD.MM.YYYY");
}